import { useState } from "react";
import { useListCompanyQuery } from "@/services/backend/company/api/company";
import { Label } from "@/shared/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { Button } from "@/shared/components/ui/button";
import { Check, ChevronsUpDown } from "lucide-react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "@/shared/components/ui/command";
import { cn } from "@/shared/lib/utils";

export function CompaniesSelect({
  companies,
  setCompanies,
}: {
  companies: string[];
  setCompanies: (companies: string[]) => void;
}) {
  const [open, setOpen] = useState(false);
  const { data: list } = useListCompanyQuery({});

  return (
    <div className="grid gap-1.5">
      <Label>Companies</Label>
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="justify-between"
          >
            {companies.length > 0
              ? companies
                  .map((id) => list?.companies.find((c) => c.id === id)?.name)
                  .join(", ")
              : "Select Companies..."}
            <ChevronsUpDown className="opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0">
          <Command>
            <CommandInput placeholder="Search Companies..." className="h-9" />
            <CommandEmpty>No company found.</CommandEmpty>
            <CommandGroup>
              {list?.companies.map((company) => (
                <CommandItem
                  key={company.id}
                  value={company.name}
                  onSelect={() => {
                    if (companies.some((cId) => cId === company.id)) {
                      setCompanies(
                        companies.filter((cId) => cId !== company.id),
                      );
                    } else {
                      setCompanies([...companies, company.id]);
                    }
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      companies.some((cId) => cId === company.id)
                        ? "opacity-100"
                        : "opacity-0",
                    )}
                  />
                  {company.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
